import axios from '../localAxios';
import { updateEmailURL } from './url';

interface UpdateEmailParams {
  newEmail: string;
  password: string;
}

export async function updateEmail({ newEmail, password }: UpdateEmailParams) {
  const url = updateEmailURL();
  const result = await axios.put(url.href, {
    new_email: newEmail,
    password: password,
  });
  return result.data;
}
